import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Ancient_Civilizations_-_Indus_Valley.png';

export default function HistoryPageIndusValleyGo() {
  return (
    <QuizPage
      title="History: Ancient Indus Valley"
      subTopic="Indus Valley"
      backgroundImage={historyImage}
      returnPath="/History-Ancient-Indusvalley"
    />
  );
}
